import { linkToClassroomCourse } from "../../links";

export function linkToCourseExamQuestionsHomepage(courseId?: string) {
  return `${linkToClassroomCourse(courseId)}/exam-questions`;
}
